import {
  Button,
  Grid,
  Dialog,
  Box,
  TextField,
  Link,
  Slide,
  Divider,
} from "@mui/material";
import { forwardRef, useEffect, useState } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import ClearIcon from "@mui/icons-material/Clear";
import Login from "./Login";
import RegisterMain from "./RegisterMain";
import { useRecoilValue } from "recoil";
import { loginState } from "../lib/Store";
import RegisterConfirm from "./RegisterConfirm";
import RegisterConfirm2 from "./RegisterConfirm2";
import RegisterForm from "./RegisterForm";
import RegisterFindPass from "./RegisterFindPass";
import pr from "../lib/pr";
import send_webview_data from "../lib/send_webview_data";
import RegisterConfirmTest from "./RegisterConfirmTest";
import Swal from "sweetalert2";
import get_cid from "../lib/get_cid";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function BottomButton(props) {
  // Login
  const { login, loaded } = props;
  const history = useHistory();
  const [openFindPass, setOpenFindPass] = useState(false);
  const [openLogin, setOpenLogin] = useState(false);
  const [openRes, setOpenRes] = useState(false);
  const [openForm, setOpenForm] = useState(false);
  const [page, setPage] = useState(1);
  const cid = get_cid();

  const clickOpenLogin = () => {
    setOpenLogin(true);
  };

  const clickCloseLogin = () => {
    setOpenLogin(false);
  };

  const clickOpenRes = () => {
    setOpenRes(true);
  };

  const clickCloseRes = () => {
    setPage(1);
    setOpenRes(false);
  };

  const clickOpenForm = () => {
    setOpenForm(true);
  };

  const clickCloseForm = () => {
    setOpenForm(false);
  };

  const goNextPage = () => {
    setPage(page + 1);
  };

  const goPreviousPage = () => {
    Swal.fire({
      title: "취소 하시겠습니까? 모든 내용이 삭제됩니다.",
      showConfirmButton: true,
      showCancelButton: true,
    })
      .then(async (result) => {
        if (result.isConfirmed) {
          setPage(1);
          setOpenRes(false);
        }
      })
      .catch((e) => Swal.fire(e));
  };

  const onOpenFindPass = () => {
    setOpenFindPass(true);
  };

  const onCloseFindPass = () => {
    setOpenFindPass(false);
  };

  return (
    <>
      {loaded && (login.mcd === undefined || login.mcd === "") ? (
        <Grid
          container
          direction="column"
          alignItems="center"
          style={{
            position: "fixed",
            bottom: "53px",
            padding: "5px 0 16px",
            zIndex: 100,
            // background: "white",
          }}
        >
          <Box
            style={{
              display: "flex",
              width: "100%",
              height: "35px",
              background: "#0092a2",
              color: "white",
              justifyContent: "center",
              alignItems: "center",
            }}
            onClick={clickOpenLogin}
          >
            로그인
          </Box>
          <Dialog
            fullScreen
            open={openLogin}
            TransitionComponent={Transition}
            onClose={clickCloseLogin}
            overflow="scroll"
          >
            <Box
              sx={{
                width: "90%",
                textAlign: "left",
                padding: "30px 0 10px 10px",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              <img src="/img/back_button_black.png" onClick={clickCloseLogin} />
              <Box
                sx={{
                  margin: "16px 0 0 10px",
                  fontSize: "25px",
                  fontWeight: "bold",
                }}
              >
                로그인
              </Box>
            </Box>
            {/* <Grid
              className="header"
              container
              direction="row"
              justifyContent="space-between"
              style={{
                width: "100%",
                padding: "5px",
                fontSize: "20px",
                background: "#0092a2",
                color: "white",
              }}
            >
              로그인
              <ClearIcon onClick={clickCloseLogin}></ClearIcon>
            </Grid> */}
            <Login
              onOpenFindPass={onOpenFindPass}
              onCloseLogin={clickCloseLogin}
            ></Login>
          </Dialog>

          <Dialog
            fullScreen
            open={openFindPass}
            TransitionComponent={Transition}
          >
            <Box
              sx={{
                width: "90%",
                textAlign: "left",
                padding: "30px 0 10px 10px",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              <img src="/img/back_button_black.png" onClick={onCloseFindPass} />
              <Box
                sx={{
                  margin: "16px 0 0 10px",
                  fontSize: "25px",
                  fontWeight: "bold",
                }}
              >
                비밀번호 찾기
              </Box>
            </Box>
            <RegisterFindPass onCloseFindPass={onCloseFindPass} />
          </Dialog>

          <Box
            style={{
              display: cid === "CID00000019" ? "none" : "flex",
              width: "100%",
              height: "35px",
              justifyContent: "center",
              alignItems: "center",
              background: "white",
            }}
            onClick={clickOpenRes}
          >
            회원가입
          </Box>

          <Dialog
            fullScreen
            open={openRes}
            onClose={clickCloseRes}
            TransitionComponent={Transition}
            overflow="scroll"
          >
            <Box
              sx={{
                width: "90%",
                textAlign: "left",
                padding: "30px 0 10px 10px",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              <img src="/img/back_button_black.png" onClick={clickCloseRes} />
              <Box
                sx={{
                  margin: "16px 0 0 10px",
                  fontSize: "22px",
                  fontWeight: "bold",
                }}
              >
                회원가입
              </Box>
            </Box>
            <Divider />

            {page === 1 ? (
              <RegisterMain
                goNextPage={goNextPage}
                goPreviousPage={goPreviousPage}
              ></RegisterMain>
            ) : null}
            {page === 2 ? (
              <RegisterForm
                goNextPage={goNextPage}
                goPreviousPage={goPreviousPage}
              ></RegisterForm>
            ) : null}
            {/* {page === 2 ? (
              <RegisterConfirm
                goNextPage={goNextPage}
                goPreviousPage={goPreviousPage}
              ></RegisterConfirm>
            ) : null}
            {page === 3 ? (
              <RegisterConfirm2
                goNextPage={goNextPage}
                goPreviousPage={goPreviousPage}
              ></RegisterConfirm2>
            ) : null}
            {page === 4 ? (
              <RegisterForm
                goNextPage={goNextPage}
                goPreviousPage={goPreviousPage}
              ></RegisterForm>
            ) : null} */}
          </Dialog>
        </Grid>
      ) : null}
    </>
  );
}

export default BottomButton;
